<div class="hbox-nowrap micro-radio">
  <span *ngIf="label" class="radio-label">{{label}}</span>
  <micro-checkbox *ngFor="let option of options" [positive]="option.positive" [negative]="option.negative"
                  [(checked)]="option.checked" (checkedChange)="changed(option)" [radio]="true" [disabled]="option.checked"
                  [ngStyle]="{'margin-right': spacing, 'margin-left': spacing}"
  >
  </micro-checkbox>
</div>
